import React, { useState } from "react";
import * as qs from "query-string";
import { useHistory } from "react-router-dom";
import { useMutation } from "react-query";

import { SSO_LOGIN, VERIFY_TOKEN } from "../api/ApiEndpoints";
import { usePost } from "../services/http-service";
import Alert from "app/components/alert/Alert";
import useAlertConfig from "app/hooks/useAlertConfig";
import {StoreContext} from "../context/Store";

export default function WithSSO(WrapperComponent) {
  function Authenticate(props) {
    const { alertConfig, showFailureAlert } = useAlertConfig(6);
    const history = useHistory();
    const params = qs.parse(location.search,{
      ignoreQueryPrefix: true,
      decoder: (str) => decodeURIComponent(str.replace(/\+/g,'%2B'))});
    const headerToken = params.headertoken;
    const returnUrl = qs.parse(location.search)["returnUrl"];
    const encDhanData = qs.parse(location.search)["encDhanData"];
    const tenantName = qs.parse(location.search)["tenant-name"];
    const { state } = React.useContext(StoreContext);
    const context = React.useContext(StoreContext);
    // const returnUrl = encodeURIComponent(qs.parse(location.search)["returnUrl"]);
    const [isLoading, setIsLoading] = useState(false);
    const [ssoLoginSuccess, setSsoLoginSuccess] = useState(false);

    const { mutate: sso_login } = useMutation((data) => usePost(data), {
      onSuccess: (loginUserData) => {
        setIsLoading(false);
        setSsoLoginSuccess(true);
        localStorage.setItem(
            "tspAuthToken",
            `Bearer ${loginUserData?.access_token}`,
        );
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("encDhanData", encDhanData);
        if(headerToken) {
          localStorage.setItem("headertoken", headerToken);
        }
        if (returnUrl) {
          history.push("/" + returnUrl);
        } else {
          history.push("/home");
        }
      },
      onError: (data) => {
        setIsLoading(false);
        showFailureAlert(data?.message ?? "Something wnet wrong!!");
      },
    });

    const BACK_URL = React.useMemo(() => {
      if (state?.clientConfigData) {
        const linkItem = context.state.clientConfigData.clientConfigs.find(
            (c) => c.name === "back-button-url",
        );
        window.sso_back_button_url = linkItem?.value;
        return linkItem?.value;
      }
    }, [state?.clientConfigData]);

    const { mutate: verifyToken } = useMutation((data) => usePost(data), {
      onSuccess: () => {},
      onError(error) {
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("tspAuthToken");
        localStorage.removeItem("isHideHeader");
        localStorage.removeItem("sso_type");
        localStorage.removeItem("sso_auth_key");
        localStorage.removeItem("sso_cust_id");
        localStorage.removeItem("sso_token");
        document.body.classList.remove("effect");
        sessionStorage.clear();
        window.location.href = BACK_URL;
        // eslint-disable-next-line no-console
        console.log(error);
      },
    });

    React.useEffect(() => {
      if (encDhanData && ssoLoginSuccess) {
        if (window.tokenVerifyInterval) {
          clearInterval(window.tokenVerifyInterval);
        }
        const interval = setInterval(() => {
          const authToken = localStorage.getItem("tspAuthToken");
          verifyToken({
            url: VERIFY_TOKEN,
            data: {},
            token: authToken,
          });
        }, 60000);

        window.tokenVerifyInterval = interval;
      }
    }, [encDhanData, ssoLoginSuccess]);

    React.useEffect(() => {
      if (!encDhanData) {
        return;
      }
      const body = {
        url: SSO_LOGIN,
        data: {
          encDhanData: encDhanData,
          tenantName: tenantName,
        },
      };
      if (encDhanData) {
        setIsLoading(true);
        sso_login(body);
        localStorage.setItem("loggedInUsingSSO", true);
      }
    }, [encDhanData]);

    return (
        <>
          {alertConfig && (
              <Alert
                  alertMessage={alertConfig.message}
                  status={alertConfig.status}
              />
          )}
          {!isLoading && <WrapperComponent {...props} />}
        </>
    );
  }

  return Authenticate;
}
